import React, { useState, useEffect, useRef,useContext } from "react";

import Axios from "../../Helpers/Interceptors";
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  Line,
  Legend,
  Cell,
  Label,
  BarChart,
  LineChart,
  AreaChart,
  Area,Sector
} from "recharts";
import {
  Table,
  Button,
  Space,
  Select,
  DatePicker,
  TimePicker,
  Tabs,
  Tag,
  Card,
} from "antd";
import "./Dashboard.scss";
import { toast } from "react-toastify";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone"; // Import the timezone plugin
import utc from "dayjs/plugin/utc";
import { useNavigate } from "react-router-dom";
import CallTickets from '../Tickets/CallTickets'
import dayjs from "dayjs";
import {getRole} from '../../Helpers/utils'
import { UserInfo } from "../../Context/userInfo";
import { object } from "prop-types";
import Map from "../Map/Map";

const calculateSeverityScore = () => {
  // Dummy AI logic: Assume an incident gets a severity score out of 100
  return Math.floor(Math.random() * 100); // Random score between 0-100
};

const sampleData = [
  { type: "Pothole Repair", estimated: 24, actual: 30 },
  { type: "Street Light Fix", estimated: 12, actual: 14 },
  { type: "Tree Removal", estimated: 48, actual: 60 },
  { type: "Water Leak", estimated: 8, actual: 9 },
];

// Function to generate a simple AI-predicted resolution time (basic average-based logic)
const predictResolutionTime = (type) => {
  const item = sampleData.find((d) => d.type === type);
  return item ? (item.estimated + item.actual) / 2 : 10; // Simple avg for prediction
};

const getNeedleCoords = (score, radius, centerX, centerY) => {
  const angle = 180 - (score / 100) * 180; // Convert score to angle (180° to 0°)
  const radians = (angle * Math.PI) / 180; // Convert to radians

  return {
    x: centerX + radius * Math.cos(radians),
    y: centerY - radius * Math.sin(radians),
  };
};

const Dashboard = () => {
  const columns = [
    {
      title: "Ticket No",
      dataIndex: "ticketNumber",
      key: "ticketNumber",
    },
    {
      title: "Request Type",
      dataIndex: "request_type",
      key: "request_type",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (record) => (
        <div
          style={{
            color:
              record === "High"
                ? "red"
                : record === "Medium"
                ? "orange"
                : (record === "Low" || !record)
                ? "green"
                : "black", // Default color if none matches
            fontWeight: "bold",
          }}
        >
          {record ? record : 'Low'}
        </div>
      ),
    },

    // {
    //   title: "Created At",
    //   dataIndex: "createdAt",
    //   key: "createdAt",

    //   render: (record) => formatDateUS(record),
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "address",
      align: "center",
      render: (_, record) => (
        <div  onClick={() => navigate(`/ticket-detail/${record.ticketNumber}`)}
        style={{ cursor: "pointer" }}>
          <i className="bx bx-show" style={{ fontSize: "20px" }}></i>
        </div>
      ),
    },
  ];


  const columns2 = [
    {
      title: "Ticket No",
      dataIndex: "ticketNumber",
      key: "ticketNumber",
    },
    {
      title: "Request Type",
      dataIndex: "request_type",
      key: "request_type",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (record) => (
        <div
          style={{
            color:
              record === "High"
                ? "red"
                : record === "Medium"
                ? "orange"
                : (record === "Low" || !record)
                ? "green"
                : "black", // Default color if none matches
            fontWeight: "bold",
          }}
        >
          {record ? record : 'Low'}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",


    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",

      render: (record) => formatDateUS(record),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "address",
      align: "center",
      render: (_, record) => (
        <div  onClick={() => navigate(`/ticket-detail/${record.ticketNumber}`)}
        style={{ cursor: "pointer" }}>
          <i className="bx bx-show" style={{ fontSize: "20px" }}></i>
        </div>
      ),
    },
  ];


  const handleViewClick = (data) => {
    const queryParams = new URLSearchParams();
    queryParams.set('status', data); // Add the status query parameter
    if (roles === 'Admin') {
      navigate(`/Agent-care?${queryParams.toString()}`);
    } else {
      navigate(`/My-tickets?${queryParams.toString()}`);
    }
  };
  const navigate = useNavigate();
  const [list, setlist] = useState([]);
  const [list1, setlist1] = useState([]);
  const [graphCount,setgraphCount] = useState({})
  const [severityScore, setSeverityScore] = useState(0);
  const [secondGraph, setSecondGraph] = useState(sampleData);


  const CHARTSCOLORS = ["#00C49F", "#FFBB28", "#FF4848"]; // Green, Yellow, Red
  const centerX = 200; // Adjust according to your chart width
  const centerY = 180; // Move down to match Pie center
  const needleLength = 80; // Length of the needle
  const needleCoords = getNeedleCoords(severityScore, needleLength, centerX, centerY);

  const { userData, updateUserData } = useContext(UserInfo);
  const [roles,setRoles]=useState(null)
  const [data ,setdata] = useState([
    { category: "Vegetation Overgrowth", SAM: 10, MaskRCNN: 5, YOLO: 8 },
    { category: "Road Damage", SAM: 25, MaskRCNN: 10, YOLO: 15 },
    { category: "Tree Damage", SAM: 20, MaskRCNN: 15, YOLO: 10 },

    { category: "Litter", SAM: 30, MaskRCNN: 25, YOLO: 20 },


  ]);

  const data1 = [
    {
      name: "Page A",
      uv: 40,
      pv: 24,
      amt: 24,
    },
    {
      name: "Page B",
      uv: 30,
      pv: 13,
      amt: 22,
    },
    {
      name: "Page C",
      uv: 20,
      pv: 98,
      amt: 22,
    },
    {
      name: "Page D",
      uv: 27,
      pv: 39,
      amt: 20,
    },
    {
      name: "Page E",
      uv: 18,
      pv: 48,
      amt: 21,
    },
    {
      name: "Page F",
      uv: 23,
      pv: 38,
      amt: 25,
    },
    {
      name: "Page G",
      uv: 34,
      pv: 43,
      amt: 21,
    },
  ];

  const severityLevels = [
    { name: "Low", value: 30, color: "#00C49F" }, // Green
    { name: "Medium", value: 40, color: "#FFBB28" }, // Yellow
    { name: "High", value: 30, color: "#FF4848" }, // Red
  ];

  const [data02,setdata02] =  useState( []);
  const  [data4,setdata4] =  useState([]);
  const   [data5,setdata5] =  useState([]);

  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0, // You’ll get the total count of records from your API response
  });
  const [pagination1, setPagination1] = useState({
    page: 1,
    size: 10,
    total: 0, // You’ll get the total count of records from your API response
  });
  const [pagination2, setPagination2] = useState({
    page: 1,
    size: 10,
    total: 0, // You’ll get the total count of records from your API response
  });




  const handlePaginationChange = (page, pagesize) => {
    console.log("asd", page, pagesize);
    setPagination((prev) => ({ ...prev, page: page, size: pagesize }));
    fetchData(page, pagesize);
  };

  const handlePaginationChange1 = (page, pagesize) => {
    console.log("asd", page, pagesize);
    setPagination1((prev) => ({ ...prev, page: page, size: pagesize }));
    fetchData(page, pagesize);
  };

  const fetchData2 = async (page,size) => {

    let url =  `agents/assigned-tickets?page=${page-1}&size=${size}`

     try {
       const response = await Axios.get(
         url
       );
       console.log(response)




           setlist(response.data.incidents);
           setdata02([
            { name: "High", value: response?.data?.priorityHigh ? response?.data?.priorityHigh :0 },
            { name: "Medium", value: response.data.priorityMedium ? response.data.priorityMedium : 0 },
            { name: "Low", value: response.data.priorityLow ? response.data.priorityLow :0 },
          ])
          getApiAnalysis(response.data.totalElements)
            setdata5([
            { department: "Parks & Recreation", resolutionRate: response.data.priorityHigh ? response.data.priorityHigh :0, satisfaction: response.data.priorityMedium ? response.data.priorityMedium : 0 },
            { department: "Sanitation", resolutionRate: response.data.priorityHigh ? response.data.priorityHigh :0, satisfaction: response.data.priorityMedium ? response.data.priorityMedium : 0 },
            { department: "Roadwork", resolutionRate: response.data.priorityHigh ? response.data.priorityHigh :0, satisfaction: response.data.priorityHigh ? response.data.priorityHigh :0 },
            { department: "Utilities", resolutionRate: response.data.priorityMedium ? response.data.priorityMedium : 0, satisfaction: response.data.priorityHigh ? response.data.priorityHigh :0 },


          ])
            setdata([
            { category: "Vegetation Overgrowth", SAM: response.data.priorityMedium ? response.data.priorityMedium : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },
            { category: "Road Damage", SAM: response.data.priorityMedium ? response.data.priorityMedium : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },
            { category: "Tree Damage", SAM: response.data.priorityMedium ? response.data.priorityMedium  : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },

            { category: "Litter", SAM: response.data.priorityMedium ? response.data.priorityMedium : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium  : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },


          ])
           setgraphCount(response.data)
           setPagination((prop) => ({
            ...prop,
            total: response.data.totalReportedIncidents || 0, // Set total from the response
          }));



     } catch (err) {
       toast.error(err.message);

     } finally {
       console.log(false);
     }


   };



  const fetchData = async (page,size) => {

   let url = `incidents/all?page=${page-1}&size=${size}`
   console.log(url)
    try {
      const response = await Axios.get(
        url
      );

console.log(response.data.totalElements)
      if(response.status == 200){
        setlist(response.data.incidents);
        setPagination((prop) => ({
          ...prop,
          total: response.data.totalElements || 0, // Set total from the response
        }));
        setdata02([
          { name: "High", value: response?.data?.priorityHigh ? response?.data?.priorityHigh :0 },
          { name: "Medium", value: response.data.priorityMedium ? response.data.priorityMedium : 0 },
          { name: "Low", value: response.data.priorityLow ? response.data.priorityLow :0 },
        ])
        getApiAnalysis(response.data.totalElements)
          setdata5([
          { department: "Parks & Recreation", resolutionRate: response.data.priorityHigh ? response.data.priorityHigh :0, satisfaction: response.data.priorityMedium ? response.data.priorityMedium : 0 },
          { department: "Sanitation", resolutionRate: response.data.priorityHigh ? response.data.priorityHigh :0, satisfaction: response.data.priorityMedium ? response.data.priorityMedium : 0 },
          { department: "Roadwork", resolutionRate: response.data.priorityHigh ? response.data.priorityHigh :0, satisfaction: response.data.priorityHigh ? response.data.priorityHigh :0 },
          { department: "Utilities", resolutionRate: response.data.priorityMedium ? response.data.priorityMedium : 0, satisfaction: response.data.priorityHigh ? response.data.priorityHigh :0 },


        ])
          setdata([
          { category: "Vegetation Overgrowth", SAM: response.data.priorityMedium ? response.data.priorityMedium : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },
          { category: "Road Damage", SAM: response.data.priorityMedium ? response.data.priorityMedium : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },
          { category: "Tree Damage", SAM: response.data.priorityMedium ? response.data.priorityMedium  : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },

          { category: "Litter", SAM: response.data.priorityMedium ? response.data.priorityMedium : 0, MaskRCNN: response.data.priorityMedium ? response.data.priorityMedium  : 0, YOLO: response.data.priorityLow ? response.data.priorityLow :0 },


        ])

        setgraphCount(response.data)

      }






    } catch (err) {
      toast.error(err.message);

    } finally {
      console.log(false);
    }


  };

  const fetchData1 = async (page,size) => {
    try {
      const response = await Axios.get(
        `incidents/guest-requests?page=${page-1}&size=${size}`
      );


      setlist1(response.data.content);

      setPagination1((prop) => ({
        ...prop,
        total: response.data.totalElements || 0, // Set total from the response
      }));
    } catch (err) {
      toast.error(err.message);
      console.log(err.message);
    } finally {
      console.log(false);
    }


  };



  const tabs = [
    {
      id: 1,
      label: `AI Graphical Insights`,
      content: (
        <>
          {" "}
          <div
            className="signup-content2 "
            style={{ paddingLeft: "2%", paddingRight: "0.5%", paddingTop: "1%" }}
          >
           <div className="row mt-3">
  {/* Card 1 - Reported Tickets */}
  <div className="col-md-3">
    <Card
      className="custm-card parent-div3"
      style={{ position: "relative" }}
    >
      <div className="custm-content">
        <h4>{graphCount.totalReportedIncidents ? graphCount.totalReportedIncidents : 0}
          <span className="ml-1">
            <i className="bx bx-show" onClick={() => handleViewClick('totalReportedIncidents')}></i>
          </span>
        </h4>
        <h7>Reported Tickets</h7>
      </div>
      <div className="d-flex cstm-btns justify-content-between">
        <div className="d-flex flex-column align-items-center">
          <p style={{ color: 'Red' }}>High</p>
          <p>{graphCount.priorityHigh ? graphCount.priorityHigh : 0}</p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p style={{ color: 'Orange' }}>Medium</p>
          <p>{graphCount.priorityMedium ? graphCount.priorityMedium : 0}</p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p style={{ color: 'green' }}>Low</p>
          <p>{graphCount.priorityLow ? graphCount.priorityLow : 0}</p>
        </div>
      </div>
      <div
        className="child-div3"
        style={{
          background: "linear-gradient(135deg, #3399ff 0%, #66ccff 100%)",
        }}
      >
        {/* Icon for Reported Tickets Card */}
        <i className="bx bx-clipboard cusotm-ixon"></i> {/* Updated icon */}
      </div>
    </Card>
  </div>

  {/* Card 2 - In Progress */}
  <div className="col-md-3">
    <Card
      className="custm-card parent-div3"
      style={{ position: "relative" }}
    >
      <div className="custm-content">
        <h4>{graphCount.inProgress ? graphCount.inProgress : 0}
          <span className="ml-1">
            <i className="bx bx-show" onClick={() => handleViewClick('inProgress')}></i>
          </span>
        </h4>
        <h7>In Progress</h7>
      </div>
      <div className="d-flex cstm-btns justify-content-between">
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
      </div>
      <div className="bottom-line-text"></div>
      <div
        className="child-div3"
        style={{
          background: "linear-gradient(135deg, #e55353 0%, #ff7b7b 100%)",
        }}
      >
        {/* Icon for In Progress Card */}
        <i className="bx bx-time-five cusotm-ixon"></i> {/* Updated icon */}
      </div>
    </Card>
  </div>

  {/* Card 3 - Assigned to Department */}
  <div className="col-md-3">
    <Card
      className="custm-card parent-div3 bg-gradient"
      style={{ position: "relative" }}
    >
      <div className="custm-content">
        <h4>{graphCount.assignedToDpt ? graphCount.assignedToDpt : 0}
          <span className="ml-1">
            <i className="bx bx-show" onClick={() => handleViewClick('assignedToDpt')}></i>
          </span>
        </h4>
        <h7 style={{marginLeft:'-10%'}}>Assigned To Department</h7>
      </div>
      <div className="d-flex cstm-btns justify-content-between">
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
      </div>
      <div className="bottom-line-text"></div>
      <div
        className="child-div3"
        style={{
          background: "linear-gradient(135deg,#f76b1c 0%,  #f9b115 100%)",
        }}
      >
        {/* Icon for Assigned to Department Card */}
        <i className="bx bx-group cusotm-ixon"></i> {/* Updated icon */}
      </div>
    </Card>
  </div>

  {/* Card 4 - Resolved */}
  <div className="col-md-3">
    <Card
      className="custm-card parent-div3"
      style={{ position: "relative" }}
    >
      <div className="custm-content">
        <h4>{graphCount.resolved ? graphCount.resolved : 0}
          <span className="ml-1">
            <i className="bx bx-show" onClick={() => handleViewClick('resolved')}></i>
          </span>
        </h4>
        <h7>Resolved</h7>
      </div>
      <div className="d-flex cstm-btns justify-content-between">
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p></p>
          <p></p>
        </div>
      </div>
      <div className="bottom-line-text"></div>
      <div
        className="child-div3"
        style={{
          background: "linear-gradient(135deg, rgb(34, 193, 195) 0%, rgb(45, 253, 180) 100%)",
        }}
      >
        {/* Icon for Resolved Card */}
        <i className="bx bx-check-circle cusotm-ixon"></i> {/* Updated icon */}
      </div>
    </Card>
  </div>
</div>

          </div>
          <div className="signup-content2 ">
            <div className="row">
              <div className="col-9">
              <div
                  className="row  "
                  style={{ marginTop: "2%", marginLeft: "2%" }}
                >
                  <div className="col-md-4 ">
                    <div className="bg-gradient card-padding rounded">
                      <div className="heading-content">
                        <h5>Service Efficiency Metrics</h5>
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data5} >
      <XAxis
  dataKey="department"
  tick={{
    angle: 25,  // Reduce the angle for better readability
    textAnchor: 'middle',
    fontSize: 12
  }}
  tickLine={false}
  interval={0}
  padding={{ bottom: 20 }}
/>
        <YAxis />
        <Tooltip />
        <Legend
      verticalAlign="top"
      align="center"
      layout="horizontal" wrapperStyle={{ marginBottom: '10px', padding: '5px' }}    // Adjusted layout for legend
     // Added top padding to increase space between legend and chart
    />
        <Bar dataKey="resolutionRate" fill="#82ca9d" name="Resolution Rate (%)" />
        <Bar dataKey="satisfaction" fill="#8884d8" name="User Satisfaction (1-5)" />
      </BarChart>
    </ResponsiveContainer>

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="bg-gradient card-padding rounded">
                      <div className="heading-content">
                        <h5>Similar Image Matching</h5>
                      </div>
                      <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data4} >
        <XAxis dataKey="date" tick={{ angle: 45, textAnchor: 'start', fontSize: 12 }} // Adjust font size here
              tickLine={false} // Removes tick lines, adding more space for the labels
              interval={0}/>
        <YAxis />
        <Tooltip />
        <Legend  verticalAlign="top"
      align="center"
      layout="horizontal" wrapperStyle={{ marginBottom: '10px', padding: '5px' }}  />
        <Line type="monotone" dataKey="originalReports" stroke="#8884d8" name="Original Reports" />
        <Line type="monotone" dataKey="duplicates" stroke="#82ca9d" name="Duplicate Reports" />
      </LineChart>
    </ResponsiveContainer>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="bg-gradient card-padding rounded">
                      <div className="heading-content">
                        <h5>Sentiment Analysis</h5>
                      </div>

                      <ResponsiveContainer width="97%" height={300} style={{padding:'5%'}}>
                       <PieChart >
                          <Pie
                            data={data02}
                            cx="50%"
                            cy="50%"

                            fill="#8884d8"
                            dataKey="value"
                            label
                          >
                            {data02.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={CHARTSCOLORS[index]}
                              />
                            ))}
                          </Pie>

                          <Tooltip />
                          <Legend  verticalAlign="top"
      align="center"
      layout="horizontal" wrapperStyle={{ marginBottom: '10px', padding: '5px' }}  />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
                <div
                  className="row "
                  style={{ marginTop: "2%", marginLeft: "2%" }}
                >
                  <div className="col-md-4">
                    <div className="bg-gradient card-padding rounded">
                      <div className="heading-content">
                        <h5>Environmental Feature Detection</h5>
                      </div>

                      <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 0, right: 30, left: 20, bottom: 0 }}>
        <XAxis dataKey="category"   tick={{ angle: 45, textAnchor: 'start', fontSize: 12 }} // Adjust font size here
              tickLine={false} // Removes tick lines, adding more space for the labels
              interval={0} />
        <YAxis />
        <Tooltip />
        <Legend  verticalAlign="top"
      align="center"
      layout="horizontal" wrapperStyle={{ marginBottom: '10px', padding: '5px' }}  />
        <Bar dataKey="SAM" stackId="a" fill="#82ca9d" name="SAM Detection" />
        <Bar dataKey="MaskRCNN" stackId="a" fill="#8884d8" name="Mask R-CNN Detection" />
        <Bar dataKey="YOLO" stackId="a" fill="#ff7300" name="YOLO Detection" />
      </BarChart>
    </ResponsiveContainer>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="bg-gradient card-padding rounded">
                      <div className="heading-content">
                        <h5>Resolution Time Estimation</h5>
                      </div>

                      <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                          data={secondGraph}
                          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                          <XAxis dataKey="type" tick={{ angle: 45, textAnchor: 'start', fontSize: 12 }} // Adjust font size here
              tickLine={false} // Removes tick lines, adding more space for the labels
              interval={0}/>
                          <YAxis />
                          <Tooltip />
                          <Legend  verticalAlign="top"
      align="center"
      layout="horizontal" wrapperStyle={{ marginBottom: '10px', padding: '5px' }}  />
                          <Bar
                            dataKey="estimated"
                            fill="#8884d8"
                            name="Estimated Time"
                          />
                          <Bar
                            dataKey="actual"
                            fill="#82ca9d"
                            name="Actual Time"
                          />
                          <Bar
                            dataKey="predicted"
                            fill="#ff7300"
                            name="AI Predicted Time"
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="bg-gradient card-padding rounded custpichart">
                      <div className="heading-content">
                        <h5>Incident Severity Score: {severityScore}</h5>
                      </div>

                      <ResponsiveContainer width="100%" height={300} className="chart-container">
  <PieChart>
    {/* Gauge Pie */}
    <Pie
      data={severityLevels}
      dataKey="value"
      cx="50%" // Center X
      cy="50%" // Center Y
      innerRadius={70}
      outerRadius={100}
      startAngle={180}
      endAngle={0}
    >
      {severityLevels.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.color} />
      ))}
    </Pie>

    {/* Needle */}
    <svg width="100%" height="100%">
      <line
        x1="50%" // Start at center
        y1="50%"
        x2={needleCoords.x} // End at calculated point
        y2={needleCoords.y}
        stroke="black"
        strokeWidth="3"
      />
      <circle cx="50%" cy="50%" r="5" fill="black" /> {/* Needle Base */}
    </svg>

    <Tooltip />
    <Legend
      verticalAlign="top"
      align="center"
      layout="horizontal"
      wrapperStyle={{ marginBottom: "10px", padding: "5px" }}
    />
  </PieChart>
</ResponsiveContainer>


                      {/* Severity Legend */}

                    </div>
                  </div>
                </div>


              </div>
              <div className="col-3" style={{ marginTop: "1.5%" }}>
                <div className="bg-gradient p-2 rounded custm-table">
                  <div className="heading-content">
                    <h5>Recent Tickets</h5>
                  </div>
                  <Table
                    dataSource={list}
                    columns={columns}
                    rowClassName={() => "custom-row"}
                    scroll={{ x: "max-content" ,y: 500}}
                    pagination={false}
                  />
                  ;
                  <div style={{ textAlign: 'center', cursor: 'pointer', marginTop: '10px' }}>
  {roles === "Admin" && (
    <span className="show-more-link" onClick={() => navigate("/Agent-care")}>
      Show more...
    </span>
  )}
  {roles === "Agent" && (
    <span className="show-more-link" onClick={() => navigate("/my-tickets")}>
      Show more...
    </span>
  )}
</div>

                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },

    {
      id: 3,
      label: `Real-Time 311 Incident Monitoring`,
      content: (
        <div className="signup-content2 mb-2">
         {/* <CallTickets/> */}

         <>
          <div
            className="signup-content2 "
            style={{
              paddingLeft: "2%",
              paddingRight: "2%",
              paddingTop: "1%",
              paddingBottom: "2%",
            }}
          >
           <div className="row mt-3">
              <div className="col-md-3">
                <Card
                  className="custm-card parent-div3"
                  style={{ position: "relative" }}
                >
                  <div className="custm-content">
                    <h4>{graphCount.totalReportedIncidents ? graphCount.totalReportedIncidents : 0 }<span className="ml-1"><i className="bx bx-show" onClick={()=>handleViewClick('totalReportedIncidents')}></i></span></h4>
                    <h7>Reported Tickets </h7>
                  </div>
                  <div className="d-flex cstm-btns justify-content-between">
                    <div className="d-flex flex-column align-items-center">
                      <p style={{color: 'Red'}}>High</p>
                      <p>{graphCount.priorityHigh ? graphCount.priorityHigh :0 }</p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p style={{color: 'Orange'}}>Medium</p>
                      <p>{graphCount.priorityMedium ? graphCount.priorityMedium : 0}</p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p style={{color: 'green'}}>Low</p>
                      <p>{graphCount.priorityLow ? graphCount.priorityLow : 0}</p>
                    </div>
                  </div>

                  {/* <div className="bottom-line-text">


                  </div> */}
                  <div
                    className="child-div3"
                    style={{
                      background:
                        "linear-gradient(135deg, #3399ff 0%, #66ccff 100%)",
                    }}
                  >
                    <i className="bx bx-message-square-detail cusotm-ixon"></i>
                  </div>
                </Card>
              </div>

              <div className="col-md-3">
                <Card
                  className="custm-card parent-div3"
                  style={{ position: "relative" }}
                >
                  <div className="custm-content">
                    <h4>{graphCount.inProgress ? graphCount.inProgress :0}<span className="ml-1"><i className="bx bx-show" onClick={()=>handleViewClick('inProgress')}></i></span></h4>
                    <h7>In Progresss</h7>
                  </div>
                  <div className="d-flex cstm-btns justify-content-between">
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                  </div>

                  <div className="bottom-line-text"></div>
                  <div
                    className="child-div3"
                    style={{
                      background:
                        "linear-gradient(135deg, #e55353 0%, #ff7b7b 100%)",
                    }}
                  >
                    <i className="bx bx-message-square-detail cusotm-ixon"></i>
                  </div>
                </Card>
              </div>

              <div className="col-md-3">
                <Card
                  className="custm-card parent-div3 bg-gradient"
                  style={{ position: "relative" }}
                >
                  <div className="custm-content">
                    <h4>{graphCount.assignedToDpt ?  graphCount.assignedToDpt :0 }<span className="ml-1"><i className="bx bx-show" onClick={()=>handleViewClick('assignedToDpt')}></i></span></h4>
                    <h7 style={{marginLeft:'-10%'}}>Assign To Department</h7>
                  </div>
                  <div className="d-flex cstm-btns justify-content-between">
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                  </div>

                  <div className="bottom-line-text"></div>
                  <div
                    className="child-div3"
                    style={{
                      background:
                        "linear-gradient(135deg,#f76b1c 0%,  #f9b115 100%)",
                    }}
                  >
                    <i className="bx bx-wallet cusotm-ixon"></i>
                  </div>
                </Card>
              </div>
              <div className="col-md-3">
                <Card
                  className="custm-card parent-div3"
                  style={{ position: "relative" }}
                >
                  <div className="custm-content">
                    <h4>{graphCount.resolved }<span className="ml-1"><i className="bx bx-show" onClick={()=>handleViewClick('resolved')}></i></span></h4>
                    <h7 >Resolved </h7>
                  </div>
                  <div className="d-flex cstm-btns justify-content-between">
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <p></p>
                      <p></p>
                    </div>
                  </div>
                  <div className="bottom-line-text"></div>
                  <div
                    className="child-div3"
                    style={{
                      background:
                        "linear-gradient(135deg, rgb(34, 193, 195) 0%, rgb(45, 253, 180) 100%)",
                    }}
                  >
                    <i className="bx bx-wallet cusotm-ixon"></i>
                  </div>
                </Card>
              </div>
            </div>
          </div>

          <div className="row m-3 ">
            <div className="col-6">
              <div
                className="bg-gradient p-2 rounded"
                style={{ position: "relative" }}
              >
                 <div
          className="card  mb-3  p-2"
          style={{
            background:
              "rgb(5, 162, 179)",
            textAlign: "center",
          }}
        >
          <h5 style={{ color: "whitesmoke" }}>Active Tickets & Incidents</h5>
        </div>
                <Table
                  dataSource={list}
                  columns={columns2}
                  rowClassName={() => "custom-row"}
                  scroll={{ y: 350 }}
                  pagination={{
                    showSizeChanger: true,
                    onChange: handlePaginationChange,

                    current: pagination.page,
                    pageSize: pagination.size,

                    total: pagination.total,

                    showTotal: (total, range) => (
                      <span style={{ color: "whitesmoke" }}>
                        Total {total} records, showing {range[0]} to {range[1]}
                      </span>
                    ),
                  }}
                />
                {/* <div
                  className="table-header"
                  style={{
                    background: "linear-gradient(60deg, #7b1fa2, #913f9e)",
                  }}
                >
                  <h4 style={{  fontFamily: 'Myriad Pro',}}>Active Tickets & Incidents</h4>
                </div> */}
                ;
              </div>
            </div>
            <div className="col-6">
              <div
                className="bg-gradient p-2 rounded"
                style={{ position: "relative" }}
              >
                 <div
          className="card  mb-3  p-2"
          style={{
            background:
              "rgb(5, 162, 179)",
            textAlign: "center",
          }}
        >
          <h5 style={{ color: "whitesmoke" }}> Guest User Tickets </h5>
        </div>
                <Table
                  dataSource={list1}
                  columns={columns2}
                  rowClassName={() => "custom-row"}
                  scroll={{ y: 350 }}
                  pagination={{
                    showSizeChanger: true,
                    onChange: handlePaginationChange1,

                    current: pagination1.page,
                    pageSize: pagination1.size,

                    total: pagination1.total,

                    showTotal: (total, range) => (
                      <span style={{ color: "whitesmoke" }}>
                        Total {total} records, showing {range[0]} to {range[1]}
                      </span>
                    ),
                  }}

                />
                {/* <div
                  className="table-header"
                  style={{
                    background:
                      "linear-gradient(135deg, #3399ff 0%, #66ccff 100%)",
                  }}
                >
                  <h4 style={{  fontFamily: 'Myriad Pro',}}>Guest User Tickets</h4>
                </div> */}
                ;
              </div>
            </div>
          </div>
          </>
        </div>
      ),
    },

    { id: 2, label: `GIS Map-based visualization`, content: <Map></Map> },
  ];





  useEffect(() => {

    if(userData){

      setRoles( getRole(userData.data?.userInfo?.roles))

      if(getRole(userData.data?.userInfo?.roles) != 'Admin'){
        tabs.splice(1,1)
      }
    }
    if(getRole(userData?.data?.userInfo?.roles)== 'Admin'){
      fetchData(pagination.page, pagination.size);
    }else if( getRole(userData?.data?.userInfo?.roles) == 'Agent'){
      fetchData2(pagination.page, pagination.size);
    }










    fetchData1(pagination1.page, pagination1.size)
    const newData = sampleData.map((d) => ({
      ...d,
      predicted: predictResolutionTime(d.type),
    }));
    setSecondGraph(newData);

    setSeverityScore(calculateSeverityScore());
  }, [userData]);


  const getApiAnalysis = async (data) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    let url =  `/similar-images-analysis`

     try {
       const response = await Axios.get(
         url
       );
       console.log(response)
       const data = response?.data


       for (let i = 0; i < data.length - 1; i++) {
        for (let j = 0; j < data.length - i - 1; j++) {
          if (data[j].month > data[j + 1].month) {
            // Swap elements
            const temp = data[j];
            data[j] = data[j + 1];
            data[j + 1] = temp;
          }
        }
      }
       const obj =  data.map((res)=> {return { date : months[res?.month] ,originalReports : res?.originalRecords ,duplicates : res?.duplicateRecords}})




      console.log(obj)
           setdata4(obj)




     } catch (err) {
       toast.error(err.message);

     } finally {
       console.log(false);
     }


   };



  const formatDateUS = (date) => {
    return new Date(date).toLocaleDateString("en-US");
  };

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];


  return (
    <div className="container-fluid" >
      <div className={`heading-content ${roles == 'Admin' ? '' : 'custm'}`} >
        <Tabs>
          {tabs.map((tab) => (
            <Tabs.TabPane key={tab.id} tab={tab.label} style={{ width: "50%" }}>
              {" "}
              {tab.content}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default Dashboard;
